var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msgtypeVideo"},[_c('video',{staticClass:"box_video",attrs:{"controls":"controls"}},[_c('source',{attrs:{"src":_vm.items.cos_file_url}})])])}
var staticRenderFns = []

export { render, staticRenderFns }